<template>
  <VView class="rules" back-button-to="/menu" :header="$t('rules.header')">
    <VText>pomóż pufkowi i sprawdź swoją zręczność w naszej grze.<br />Omijaj przeszkody, zbieraj kryształy i postaraj się uzyskać wynik, który zapewni ci wysokie miejsce w rankingu graczy!</VText>
    <VText>Po ukończeniu gry otrzymasz możliwość wzięcia udziału w konkursie. wystarczy, że odpowiesz na proste pytanie i uzupełnisz wspólnie z opiekunem formularz osobowy, abyśmy mogli się z wami skontaktować w przypadku wygranej.</VText>
    <VText>Nie zapomnij zasubskrybować też <a href="https://www.youtube.com/@PRZYGODY_PUFKA?sub_confirmation=1" target="_blank">pufkowego kanału na Youtube!</a></VText>
    <VText>Spośród 100 najlepszych wyników jury wybierze najbardziej kreatywne i oryginalne odpowiedzi, a ich autorów nagrodzi jednym z zestawów nagród.</VText>
    <VText center>Konkurs trwa od 19.02 do 10.03.2024.<br />Szczegóły znajdziesz w <a href="regulamin.pdf" target="_blank">regulaminie</a>.</VText>
  </VView>
</template>

<script>
export default {
  name: 'Rules',
};
</script>

<style lang="scss" scoped>
.rules {
}
</style>
